import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL } from '../../utils';

const onDeviceTypesListIsLoading = isLoading => ({
    type: CONSTANTS.ON_DEVICE_TYPES_LIST_IS_LOADING,
    payload: { isLoading }
});

const onDeviceTypesList = data => ({
    type: CONSTANTS.ON_DEVICE_TYPES_LIST,
    payload: { data }
});

// ========= THUNKS ============

/**
 * fetchAllDeviceTypes
 * - Fetching all device types
 * @since 1.8.0
 *
 *
 * @returns {Promise}
 */
export const fetchAllDeviceTypes = () => (dispatch, getState) => {
    const deviceTypesState = getState().deviceTypes.get('list');
    if (deviceTypesState.get('isLoading')) return;
    dispatch(onDeviceTypesListIsLoading(true));

    return api(REQUEST_URL.DEVICE_TYPES_LIST, METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onDeviceTypesList(fromJS(res.body)));
                dispatch(onDeviceTypesListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onDeviceTypesListIsLoading(false));
            throw err;
        });
};
